<template>
  <div class="info-list-bottom">
    <div>
      <ul class="info-dataList">
        <li
          v-for="(item,index) in productList"
          :key="index"
          :class="isLinkBot==index ? 'li-style2 li-check-style2' : 'li-style2'"
          @click="chooseLi2(item,index)"
        >
          {{item.name}}
          ( {{item.value.length}} )
        </li>
      </ul>
      <div class="info-list-list" v-for="(item,index) in productList" :key="index">
        <div v-if="item.name=='贷款' && leave==item.name">
          <div class="product-div" v-for="(ctem, index) in item.value" :key="index">
            <div class="list-top-time">
              <div>2022年5月9日 14:33</div>
            </div>
            <div class="bank-list">
              <div class="list-com bank-top">
                <div class="bank-top-left">
                  <div class="bank-left-img">
                    <img :src="ctem.thumbnail" alt />
                  </div>
                  <div>
                    <p class="product-list-title">{{ctem.name}}</p>
                    <p class="product-list-summary">手续简单抵押率高</p>
                  </div>
                </div>
              </div>
              <div class="list-com bank-bottom">
                <p v-html="ctem.digest"></p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.name!='贷款' && leave==item.name">
          <div class="product-div" v-for="(ctem, index) in item.value" :key="index">
            <div class="list-top-time">
              <div>2022年5月9日 14:33</div>
            </div>
            <div class="bank-list product-safe">
              <div class="product-safe-left">
                <img :src="ctem.thumbnail" alt />
              </div>
              <div class="product-safe-right">
                <div>
                  <p class="product-list-title">{{ctem.name}}</p>
                  <div class="safe-right-height">
                    <p v-html="ctem.digest" class="product-list-summary"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      productList: [],
      isLinkBot: '0',
    }
  },
  mounted() {
    this.fatchdata()
  },
  methods: {
    chooseLi2(item, i) {
      this.isLinkBot = i
      this.leave = item.name
    },
    fatchdata() {//推荐产品
      this.$fetchPost(URL.recommendProduct.url, { phoneNo: localStorage.getItem('phone') }).then(res => {
        this.productList = res.data.data;
        this.leave = res.data.data[0].name
      })
    },
  }
}
</script>

<style lang="less" scoped>
.info-list-bottom {
  width: 355px;
  margin: auto;
  .product-list-title {
    margin: 12px 0 8px 18px;
    font-size: 14px;
    font-weight: Bold;
  }
  .product-list-summary {
    margin-left: 18px;
    font-size: 10.5px;
    font-weight: Regular;
  }
  .product-div{
    // width: ;
    .list-top-time{
        margin-top: 15px;
        font-size: 11px;
        font-weight: 400;
        color: #333333;
    }
  }
  .info-dataList {
    width: 335px;
    margin: 25px auto 0 auto;
    display: flex;
    .li-style2 {
      width: 69px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      font-size: 11px;
      color: #666666;
      font-weight: 400;
      background: url("../../assets/publicImg/li-bg6.png") no-repeat 100%;
      background-size: 100% 100%;
      &:not(:first-child) {
        margin-left: 5px;
      }
    }
    .li-check-style2 {
      font-weight: 500;
      color: #fc6e09;
    }
  }
  .bank-list {
    width: 355px;
    padding: 10.5px 0 9.5px 0;
    margin-top: 2px;
    background: url('../../assets/publicImg/con-bg.png') no-repeat;
    background-size: 100% 100%;
    .list-com {
      width: 335px;
      margin: auto;
    }
    .bank-top,
    .bank-top-left {
      height: 65px;
      display: flex;
    }
    .bank-left-img {
      width: 128px;
      height: 65px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bank-top {
      justify-content: space-between;
      align-items: center;
    }
    .bank-bottom {
      height: 56.5px;
      margin-top: 12px;
      padding: 3.5px 0;
      line-height: 1.58;
      overflow: hidden;
      background: #fffefb;
      p {
        height: 14px;
        padding-left: 17.5px;
        font-size: 10px;
      }
    }
  }
  .product-safe {
    height: 135px;
    padding: 0;
    align-items: center;
    display: flex;
    .product-safe-left {
      width: 128px;
      height: 110px;
      margin-left: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .product-safe-right {
      // border: 1px solid;
      width: 195.5px;
      height: 110px;
      margin-left: 11.5px;
      position: relative;
      .safe-right-but {
        position: absolute;
        bottom: 0;
        right: 0;
      }
      .safe-right-height {
        height: 45px;
        overflow: hidden;
      }
      .product-list-summary {
        margin-left: 0;
        height: 14px;
      }
      .product-list-title {
        margin: 10px 0 5px 6.5px;
      }
    }
  }
}
</style>